import { render, staticRenderFns } from "./ImageBlocks.vue?vue&type=template&id=6bbf4512&"
import script from "./ImageBlocks.vue?vue&type=script&lang=js&"
export * from "./ImageBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports